module.exports = __webpack_public_path__ + "static/media/NJ0151-53M_02.362ed567.png";